import React from "react";
import { Section, sectionSpacingY } from "components/section";
import { Accordion } from "ui/accordion";
import { TextTitle } from "ui/text";
import { Link } from "ui/link";
import { integrationsCount } from "../../constants/integrations";

const faqItems = [
  {
    title: "What is a destination?",
    content: (
      <>
        A destination is any of the {integrationsCount}+ integrations that Hightouch lets you sync data to. Multiple
        instances of the same destination will only be counted once. Read{" "}
        <Link href="/docs/pricing/ss-pricing" variant="inlineDark" target="_blank">
          our documentation
        </Link>{" "}
        to learn more about{" "}
        <Link variant="inlineDark" target="_blank" href="/docs/pricing/ss-pricing#destinations">
          what counts as a destination
        </Link>
        .
      </>
    ),
  },
  {
    title: "What is a source?",
    content:
      "A source is wherever business data is stored. The most frequently used sources include data warehouses like Snowflake and Google BigQuery. Sources can also be databases, CSV files, SFTP, or BI tools.",
  },
  {
    title: "Do I need to have a customer data platform to use AI Decisioning?",
    content: "No, all of our products are composable and can be purchased separately.",
  },
  {
    title: "What if I have a billing-related question?",
    content:
      "For questions related to payments processing, invoices, discounts, overages, or any other billing-related topics, please message us on Intercom or email us, and we will help you resolve the question.",
  },
];

export function Faq() {
  return (
    <Section my={0} pb={sectionSpacingY}>
      <TextTitle align="center" mobileAlign="center" size="lg" title="Frequently asked questions" />
      <Accordion items={faqItems} maxW="700px" mx="auto" mt={{ base: "bigger", md: "biggest" }} />
    </Section>
  );
}
